var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2468 13.109L2.68723 20.9016C2.28551 21.0615 1.90387 21.0265 1.54232 20.7967C1.18077 20.5669 1 20.2323 1 19.7927V4.20733C1 3.76774 1.18077 3.43305 1.54232 3.20327C1.90387 2.97349 2.28551 2.93852 2.68723 3.09837L21.2468 10.891C21.7489 11.1108 22 11.4805 22 12C22 12.5195 21.7489 12.8892 21.2468 13.109ZM3.41033 17.9944L17.6915 12L3.41033 6.00564V10.2017L10.6413 12L3.41033 13.7983V17.9944Z",
    fill: "#B7C2CE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendDefault);
export default __webpack_public_path__ + "static/media/send_default.9b5badfa6483b9ddf9fdec2d08600b0d.svg";
export { ForwardRef as ReactComponent };